<template>
    <v-card color="#000">
        <v-card-title>
            <h1 class="display-2">Companies Create</h1>
        </v-card-title>
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex d-flex xs12 md12 lg2>
                    <v-card color="purple" dark>
                        
                        <v-card-title primary class="title">Speichern</v-card-title>
                        <v-card-text>
                        
                            <v-layout row justify-center>
                            <v-btn flat fab class="success" small>
                                <v-icon small>check</v-icon>
                            </v-btn>
                            <v-btn flat fab class="error" small>
                                <v-icon small>close</v-icon>
                            </v-btn>
                            </v-layout>                  

                        <v-divider class="my-3 grey"></v-divider>
                        
                            Hier könnte jetzt ein erklärender Hilfetext
                            für das nebenstehende Formular sein
                            
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex d-flex :class="(!media) ? '' : 'xs12 lg7'">
                    <v-layout row wrap>
                        <v-flex d-flex>
                            <v-card color="indigo" dark>
                                <v-card-title class="title">Stammdaten</v-card-title>
                                <v-card-text>
                                    <v-container fluid grid-list-md>
                                    <v-layout align-start justify-start row wrap>
                                       
                                        <v-flex d-flex xs4>
                                            <v-text-field            
                                                placeholder="Placeholder"
                                                solo-inverted
                                                dark  
                                                flat
                                                hint="Namen eingeben zack zack"
                                                prepend-inner-icon="edit"
                                                clearable
                                            ></v-text-field>   
                                        </v-flex>
                                        <v-flex xs1></v-flex> 
                                        <v-flex xs7></v-flex> 
                                    
                                      
                                    </v-layout>
                                    <v-layout align-start justify-start row wrap>
                                        <v-flex xs8>
                                            <v-text-field            
                                                placeholder="Placeholder"
                                                solo-inverted
                                                dark  
                                                flat
                                                hint="Namen eingeben zack zack"
                                                prepend-inner-icon="edit"
                                                clearable
                                            ></v-text-field> 
                                        </v-flex>
                                        <v-flex xs1></v-flex>
                                        <v-flex xs3></v-flex>                                        
                                    </v-layout>
                                    <v-layout align-start justify-start row wrap>
                                        <v-flex xs10>
                                            <v-text-field            
                                                placeholder="Placeholder"
                                                solo-inverted
                                                dark  
                                                flat
                                                hint="Namen eingeben zack zack"
                                                prepend-inner-icon="edit"
                                                clearable
                                            ></v-text-field> 
                                        </v-flex>
                                        <v-flex xs1></v-flex>
                                        <v-flex xs1></v-flex>                                        
                                    </v-layout>
                                    <v-layout align-start justify-start row wrap>
                                        <v-flex md8></v-flex>
                                        <v-flex md1></v-flex> 
                                        <v-flex md3></v-flex>                                         
                                    </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        
                        <v-flex d-flex xs12 v-if="minis">
                            
                            <v-layout row wrap>
                                <v-flex
                                    
                                    d-flex
                                    
                                    >
                                   
                                    <v-card
                                      color="red lighten-2"
                                      dark
                                    >
                                        <v-card-title class="title">Adressdaten</v-card-title>
                                        <v-card-text>                                            
                                            
                                            <v-container fluid grid-list-md>
                                                
                                                        
                                                <v-layout align-start 
                                                            justify-start 
                                                            row wrap 
                                                            >
                                                    <v-flex d-flex xs7>
                                                        <v-autocomplete                        
                                                            label="Auswahl Adresses"                                
                                                            dark                                                                                                              
                                                            v-bind:items="types"     
                                                            item-text="name"
                                                            v-model="result"                                                
                                                            return-object
                                                            flat
                                                            solo-inverted
                                                            prepend-inner-icon="search"
                                                            
                                                        >    
                                                            <template
                                                                slot="selection"
                                                                slot-scope="data"
                                                            >
                                                                
                                                            </template> 
                                                            <template
                                                                slot="item"
                                                                slot-scope="data"
                          >
                                                                <template v-if="typeof data.item !== 'object'">
                                                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                                                </template>
                                                                <template v-else>

                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                                                        <v-list-tile-sub-title v-html="data.item.id"></v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </template>
                                                        </v-autocomplete>                                                                                                                
                                                    </v-flex>
                                                    <v-flex xs1></v-flex> 
                                                    <v-flex xs4>
                                                        
                                                        
                                                    </v-flex>  
                                                    
                                                </v-layout>
                                                <v-layout align-start justify-start row wrap v-if="Object.keys(result).length">
                                                    <v-flex d-flex xs12>
                                                        <v-card>
                                                            <v-card-text>
                                                                <p><b>{{result['name']}}</b>  </br> 
                                                                    {{result['id']}} {{result['wert']}}                                                            
                                                                </p>
                                                            </v-card-text>
                                                            <v-card-action>
                                                                <v-icon class="mt-1" v-on:click.stop="remove(result)">
                                                                    close
                                                                </v-icon>
                                                            </v-card-action>
                                                        </v-card>                                                                                                                  
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                     
                                    </v-card>
                                    
                                </v-flex>
                                <v-flex
                                    
                                    d-flex
                                    
                                    >
                                   
                                    <v-card
                                      color="red lighten-2"
                                      dark
                                    >
                                        <v-card-title class="title">Tochterkonzerne</v-card-title>
                                        <v-card-text>                                            
                                            
                                            <v-container fluid grid-list-md>
                                                
                                                        
                                                <v-layout align-start 
                                                            justify-start 
                                                            row wrap>                                                            
                                                    <v-flex d-flex xs7>
                                                        
                                                        <v-autocomplete                        
                                                            label="Auswahl Types"                                
                                                            dark                                                                                                              
                                                            v-bind:items="types"     
                                                            item-text="name"
                                                            v-model="result1"                                                
                                                            multiple
                                                            return-object
                                                            flat
                                                            solo-inverted
                                                            prepend-inner-icon="search"
                                                            
                                                        >    
                                                            <template
                                                                slot="selection"
                                                                slot-scope="data"
                                                            >
                                                                
                                                            </template> 
                                                            <template
                                                                slot="item"
                                                                slot-scope="data"
                          >
                                                                <template v-if="typeof data.item !== 'object'">
                                                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                                                </template>
                                                                <template v-else>

                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title v-html="getTitle(data.item)"></v-list-tile-title>
                                                                        <v-list-tile-sub-title v-html="getSubTitle(data.item)"></v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </template>
                                                        </v-autocomplete>
                                                        
                                                    </v-flex>
                                                    <v-flex xs1></v-flex> 
                                                    <v-flex xs4>  
                                                        
                                                    </v-flex>  
                                                    <v-layout row wrap justify-start align-start v-if="result1.length">                                                       
                                                        <v-flex d-flex xs10 v-for="res in result1" :key="res.id">  
                                                            <v-card>
                                                                <v-card-text>
                                                                     <p><b>{{res.name}}</b>  </br> 
                                                                    {{res.id}} {{res.wert}} </br>                                                             
                                                                    </p>
                                                                </v-card-text>
                                                                <v-card-action>
                                                                    <v-icon class="mt-1" v-on:click.stop="remove1(res)">
                                                                        close
                                                                    </v-icon>
                                                                </v-card-action>
                                                            </v-card>
                                                                                                                       
                                                        </v-flex>
                                                    </v-layout>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                     
                                    </v-card>
                                    
                                </v-flex>
                            </v-layout>
                            
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex d-flex xs12 lg3 v-if="media">
                    <v-layout row wrap>
                    <v-flex

                        d-flex

                        >
                    <v-card color="green lighten-2" dark>
                        <v-card-title class="title">Texte</v-card-title>
                        <v-card-text>
                            
                            <v-layout row wrap align-start justify-start>
                                <v-flex d-flex xs6>
                                    <v-card dark flat color="transparent">
                                        <v-card-title>
                                            Text Upload
                                        </v-card-title>
                                        <v-img 
                                            height="100px"
                                            src=""
                                            contain

                                        >                        
                                        </v-img>

                                        <v-card-actions>
                                            <v-flex d-flex>
                                                <v-btn flat class="file-btn">                             
                                                    <v-icon x-large >backup</v-icon>                             
                                                    <input type="file" v-on:change="onFileChange"/>
                                                </v-btn>
                                            </v-flex>
                                        </v-card-actions>
                                    </v-card>

                                </v-flex>
                                <v-flex d-flex>
                                    <v-container grid-list-xs>
                                        <v-layout column justify-start>
                                            <v-flex xs12>
                                                <v-card dark flat color="transparent">

                                                    <v-img 
                                                        src=""
                                                        height="60px"
                                                        contain
                                                    >
                                                    </v-img>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn flat small  v-on:click="">
                                                            <v-icon>close</v-icon>
                                                        </v-btn>                                
                                                    </v-card-actions>                                                                                                                 
                                                </v-card>
                                            </v-flex>                                                                   
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                        <v-flex

                        d-flex

                        >
                    <v-card color="green lighten-2" dark>
                        <v-card-title class="title">Logos</v-card-title>
                        <v-card-text>
                            <v-layout row wrap align-start justify-start>
                                <v-flex d-flex xs6>
                                    <v-card dark flat color="transparent">
                                        <v-card-title>
                                            Logo Upload
                                        </v-card-title>
                                        <v-img 
                                            height="100px"
                                            src=""
                                            contain

                                        >                        
                                        </v-img>

                                        <v-card-actions>
                                            <v-flex d-flex>
                                                <v-btn flat class="file-btn">                             
                                                    <v-icon x-large >backup</v-icon>                             
                                                    <input type="file" v-on:change="onFileChange"/>
                                                </v-btn>
                                            </v-flex>
                                        </v-card-actions>
                                    </v-card>

                                </v-flex>
                                <v-flex d-flex>
                                    <v-container grid-list-xs>
                                        <v-layout column justify-start>
                                            <v-flex xs12>
                                                <v-card dark flat color="transparent">

                                                    <v-img 
                                                        src=""
                                                        height="60px"
                                                        contain
                                                    >
                                                    </v-img>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn flat small  v-on:click="">
                                                            <v-icon>close</v-icon>
                                                        </v-btn>                                
                                                    </v-card-actions>                                                                                                                 
                                                </v-card>
                                            </v-flex>                                                                   
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>
 
                        </v-card-text>
                    </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
                    
            </v-layout>
        </v-container>
    </v-card>
</template>
<script>
    export default {   
   
    data() {
        return {  
            result:[],
            result1:[],
            types: [
                {name:'test1', id:'1', wert:'pooop'},                
                {name:'test2', id:'2', wert:'pooop'},
                {name:'test3', id:'3', wert:'pooop'},
                {name:'test4', id:'4', wert:'pooop'},
                {name:'test5', id:'5', wert:'pooop'},
                {name:'test6', id:'6', wert:'pooop'},
                {name:'test7', id:'7', wert:'pooop'}
            ],
            elements:0,
            elements1:0,
            minis: true,
            media: true,            
            
            
        }
    },
    computed: {
        
    },
    methods: {
        getTitle (item) {
            return item['name']
        },
        getSubTitle (item) {
            return item['wert']
        },
        remove (item) {
            
            this.result = []
        },
        remove1 (item) {
            
            const index = this.result1.map(function(e) {return e.id}).indexOf(item.id)
            if (index >= 0) this.result1.splice(index, 1)
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.createImage(files[0]);
        },
        createImage(file) {
            
            var reader = new FileReader();
            var data = new FormData();
            var vm = this;
            
            data.append('logo', file);
            //data.append('name', this.mk.name.replace(' ', '_'))
            //data.append('timestamp', new Date().getTime())
            //data.append('mainfolder', this.mk.firmen[0].id);

            reader.onload = (e) => {
                //this.logoSrc = e.target.result;
            };
            /*
            this.$store.dispatch('postLogo',data).then((response)=>{                 
                reader.readAsDataURL(file);            
                vm.mk.logos.push(response);
            })
            */
            
        },
        removeImage: function (index) {
            //this.mk.logos.splice(index,1);
        },
    }
    
    
}
</script>